import {SkeletonAvatar, SkeletonText, Stack} from '@primer/react/experimental'
import {CommentLayout} from './CommentLayout'

/**
 * A single thread preview skeleton that mimics the ThreadPreview component structure
 */
function CommentsSkeletonItem({lines}: {lines: number}) {
  return (
    <CommentLayout
      data-testid="thread-preview-skeleton-item"
      header={
        <Stack direction="horizontal" align="center" gap="condensed">
          <SkeletonAvatar size={24} />
          <SkeletonText size="bodyMedium" />
        </Stack>
      }
    >
      <SkeletonText size="bodyMedium" lines={lines} />
    </CommentLayout>
  )
}

/**
 * Renders skeleton loading states for thread previews.
 * Used as a fallback while thread preview data is being fetched.
 */
export function CommentsSkeleton() {
  return (
    <Stack gap="normal" data-testid="thread-preview-skeleton">
      <CommentsSkeletonItem lines={1} />
      <CommentsSkeletonItem lines={3} />
      <CommentsSkeletonItem lines={2} />
    </Stack>
  )
}
